export const notInitialized = (name: string) => ():any => console.error(`${name} is not initialized!`);